import { useCallback, useEffect, useState } from "react";
import IdentityVerificationService from "../../services/IdentityVerificationService";

const EMPTY = [];

// Feature failures never reject the core reservation request or clear its rows.
export default function useIdentityVerificationStatuses(reservations = EMPTY, enabled = false) {
  const [revision, setRevision] = useState(0);
  const [result, setResult] = useState(null);
  const reload = useCallback(() => setRevision((value) => value + 1), []);
  const key = JSON.stringify((reservations || []).map((row) => [
    String(row?.host_id || ""), String(row?.guest_reservation_id || ""),
  ]));

  useEffect(() => {
    if (!enabled) {
      setResult(null);
      return undefined;
    }
    let cancelled = false;
    const ids = [...new Set((reservations || []).map((row) => row?.guest_reservation_id)
      .filter(Boolean).map(String))];
    async function load() {
      try {
        const statuses = {};
        for (let offset = 0; offset < ids.length; offset += 100) {
          if (cancelled) return;
          const rows = await IdentityVerificationService.listStatuses(ids.slice(offset, offset + 100));
          for (const row of rows) statuses[String(row.guest_reservation_id)] = row;
        }
        if (!cancelled) setResult({ key, statuses });
      } catch (_error) {
        if (!cancelled) {
          setResult((previous) => previous?.key === key && previous?.statuses
            ? { ...previous, error: true }
            : { key, error: true });
        }
      }
    }
    load();
    return () => { cancelled = true; };
  }, [reservations, enabled, revision, key]);

  const lookup = (id) => {
    if (!enabled || result?.key !== key) {
      return { state: "loading" };
    }
    const response = result?.statuses?.[String(id)];
    return response
      ? { state: "loaded", response, stale: Boolean(result?.error), retry: reload }
      : { state: "error", retry: reload };
  };
  return { lookup, reload };
}
